define('image-loader/image-loader',['require','exports','module','jquery'],function (require, exports, module) {

	var jQuery = require('jquery');

	/*
	 * Saved previous loaded images here for faster retrieval.
	 */
	var imgs = {},
		SVG = 'SVG Document';

	module.exports = {
		/**
		 * Dynamically load image with failure fallback. Passes back a promise
		 * which will be resolved or rejected depending on image load result.
		 * Saves previously laoded images in 'imgs' obejct cache.
		 *
		 * Passing 'true' as second argument to load will ignore cache and reload
		 * image, replacing result in cache with new result.
		 * 
		 * @return {promise} resolved if image loads successfully, rejected in 
		 *                   image load errors.         
		 */
		load: function (src, clearFromCache) {

			if(imgs[src] && clearFromCache) {
				/*
				 * If image is cached in imgs array, and clearFromCache
				 * is true, delete cached record and recreate.
				 */
				delete imgs[src];
			}
				
			return (imgs[src] = imgs[src] || jQuery.Deferred(function (def) {
				if (!src) {
					def.reject(src, null);
					return def;
				}
				var img = document.createElement('img');
				img.onload = function () {
					/*
					 * IE needs a naturalHeight check for images
					 * but, ie doesn't assign naturalHeight for svg.
					 * So check the mimeType.
					 */
					if (img.naturalHeight || img.mimeType === SVG) {
						img.onload = img.onerror = null;
						def.resolve(src, img);
					} else {
						img.onerror();
					}
				};
				img.onerror = function () {
					img.onload = img.onerror = null;
					def.reject(src, img);
				};
				img.src = src;
			})).promise();
		}
	};
});
